/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react"
import { Location, SuccessFetch } from "types"
import { useApi } from "utils"

export type Response = {
  payload: Location[]
}

export function useDropdownLocation() {
  const api = useApi()
  const [data, setData] = useState<Response["payload"]>([])
  const [isLoadingLocation, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)

    api
      .get("/location/")
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload

        setData(data)
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()

    return () => {
      setData([])
      setLoading(false)
    }
  }, [])

  return {
    data,
    isLoadingLocation,
    dropdownLocation: data?.map((item) => ({
      ...item,
      label: item.location_name,
      value: item.location_id.toString()
    })),
    refetch
  }
}
